import { CountUp } from "countup.js";
export function countUp(target: string = ".counter", opts: any = {}) {
  const List = $(target);
  if (!List.length) return;
  const defaults = {
    startVal: 0,
    enableScrollSpy: true,
    duration: 0.7,
    useEasing: false,
    scrollSpyDelay: 0,
    useGrouping: false,
    ...opts,
  };
  List.each((_i, item) => {
    const Num = Number($(item).text());
    if (!Num || typeof Num !== "number") return;
    new CountUp(item, Num, defaults);
  });
}
/* 点击展开尊贵版（filpHeight） */
export function filpHeight(btn: string | HTMLElement, content: string | HTMLElement, L: number) {
  const BTN = typeof btn === "string" ? $(btn) : $(btn as HTMLElement);
  const CONTENT = typeof content === "string" ? $(content) : $(content as HTMLElement);
  if (!CONTENT.length || !BTN.length) return;
  BTN.addClass("active");
  CONTENT.css("height", "auto");
  const LH = (CONTENT.css("lineHeight") ? parseInt(CONTENT.css("lineHeight").replace("px", "")).toFixed(2) : 32) as number;
  const H = CONTENT.outerHeight();
  CONTENT.css("-webkit-line-clamp", L + "");
  const minH = CONTENT.height() as number;
  const showH = minH == H ? (L * LH > minH ? minH : L * LH) : minH;
  CONTENT.css("-webkit-line-clamp", "unset");
  CONTENT.css("transition", ".3s ease-out");
  function filp() {
    CONTENT.toggleClass("active");
    BTN.toggleClass("active");
    const FLAG = CONTENT.hasClass("active");
    if (FLAG) {
      CONTENT.css("height", showH + "px");
      CONTENT.css("overflow", "hidden");
      setTimeout(function () {
        CONTENT.css("-webkit-line-clamp", L + "");
      }, 300);
    } else {
      CONTENT.css("height", H + "px");
      CONTENT.css("-webkit-line-clamp", "unset");
    }
  }
  filp();
  BTN.on("click", filp);
}
/*! 平均分圆 */
export function circleRender(that: string) {
  const PARENT = $(that).parent().parent();
  const ITEM = $(that);
  const r = PARENT.width()! / 2;
  const COUNT = ITEM.length;
  const pieceDeg = 360 / COUNT;
  for (let i = 0; i < COUNT; i++) {
    let t = 180 - i * pieceDeg;
    t = (Math.PI / 180) * t;
    const X = $(ITEM[i]).outerWidth()! / 2;
    const Y = $(ITEM[i]).outerHeight()! / 2;
    const x = Math.sin(t) * r - X;
    const y = Math.cos(t) * r - Y;
    $(ITEM[i]).css({
      transform: `translate(${x}px,${y}px)`,
    });
  }
}

export function importGoogleTranslate(opts?: GoogleTranslate) {
  const trigger = opts?.trigger || "language-trigger";
  const wrapper = opts?.wrapper || "language";
  const src = opts?.src || "//translate.google.com/translate_a/element.js?cb=loadPlugin";
  const renderCSS = opts?.renderCSS || false;
  const buttonTrigger = document.getElementById(trigger) as HTMLElement;
  const pluginContainer = document.getElementsByClassName(wrapper)[0] as HTMLElement;
  const tag = document.createElement("script");
  const styleSheel = document.createElement("style");
  styleSheel.type = "text/css";
  styleSheel.innerHTML = "";
  tag.async = true;
  tag.defer = true;
  tag.src = src;
  tag.onerror = () => {
    console.error("Failed to load Google Translate script");
  };
  document.getElementsByTagName("head")[0].appendChild(tag);
  if (renderCSS) {
    document.getElementsByTagName("head")[0].appendChild(styleSheel);
  }
  const loadPlugin = () => {
    try {
      new window.google.translate.TranslateElement(
        {
          pageLanguage: "en",
          layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
          autoDisplay: true,
        },
        "google_translate_element"
      );
      buttonTrigger?.addEventListener("click", () => {
        buttonTrigger.style.display = "none";
        pluginContainer.style.display = "block";
      });
      window.loadPlugin = null;
    } catch (error) {
      console.error("Error initializing Google Translate plugin:", error);
    }
  };
  window.loadPlugin = loadPlugin;
}
